import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import moment from 'moment-timezone';
import getQueryUtils, { attributeKeys } from '@/pages/partners/queryUtils';
import { $aggregations_distance, tags_educator } from '@/utils/query-helpers';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4,
    distance = {},
    site
  } = props;

  const [timestamp] = useState(moment().toISOString());

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  const query = {
    where: {
      eager: {
        $aggregations: $aggregations_distance(distance, ''),
        $where: {
          ...tags_educator(),
          $and: [...queryUtils.where],
          sites: {
            $where: {
              id: site.id
            }
          }
        }
      }
    },
    pagination: {
      page: search.page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  };

  const result = useConnect('user.find', query, {
    keepPreviousData: true
  });

  return result;
}
